module.exports = __webpack_public_path__ + "img/segment-refresh.ba36cc74.svg";